import { getStaticPathsFromStoryblokSlugGenerator } from '@cinch-nx/storyblok-utils'

const path = 'servicing'
export const getStaticPaths = getStaticPathsFromStoryblokSlugGenerator(path)

export { getStaticProps } from '@cinch-nx/feature-servicing'
export { ServicingPage as default } from '@cinch-nx/feature-servicing'
